import React, { useState } from "react";
import axios from "axios";
import { Button, Spinner } from "@fluentui/react-components";

const GeneratePrompt = () => {
    const [promptText, setPromptText] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");

    const handleTOATOC = async () => {
        if (!promptText) {
            setMessage("Please enter a valid prompt.");
            return;
        }
        setLoading(true);
        setMessage("");
        try {
            const response = await axios.get(
                `https://mensreabackend.openteqdev.com/generate-toc-toa?prompt=${encodeURIComponent(promptText)}`
            );

            if (response.status === 200 && response.data) {
                setMessage("Content appended to Word document successfully!");
                appendContentToWord(response.data);
                setPromptText("");
            } else {
                setMessage("Error: Empty or invalid API response.");
            }
        } catch (error) {
            console.error(error&&error?.response&&error?.response?.data);
            setMessage(error&&error?.response&&error?.response?.data);
        } finally {
            setLoading(false);
        }
    };

    const appendContentToWord = async (html) => {
        try {
            await Word.run(async (context) => {
                const body = context.document.body;
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, "text/html");

                // Traverse and append content
                traverseAndAppend(doc.body, body);

                await context.sync();
                console.log("Content successfully appended to Word document.");
            });
        } catch (error) {
            console.error("Error appending content to Word document:", error);
            setMessage("Failed to append content to Word document.");
        }
    };

    const traverseAndAppend = (sourceNode, targetBody) => {
        Array.from(sourceNode.childNodes).forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
                switch (node.tagName) {
                    case "H2":
                        targetBody.insertParagraph(node.textContent, Word.InsertLocation.end).font.set({
                            bold: true,
                            size: 14,
                        });
                        break;
                    case "P":
                        targetBody.insertParagraph(node.textContent.trim(), Word.InsertLocation.end).font.set({
                            size: 12,
                        });
                        break;
                    case "UL":
                        traverseAndAppend(node, targetBody); // Handle nested list items
                        break;
                    case "LI":
                        targetBody.insertParagraph(`• ${node.textContent.trim()}`, Word.InsertLocation.end).font.set({
                            size: 12,
                        });
                        break;
                    default:
                        break;
                }
            }
        });
    };

    return (
        <div style={{ marginTop: "10px", textAlign: "center", position: "relative" }}>
            {/* <div style={{ marginBottom: "10px" }}>
                <label htmlFor="prompt">Enter Prompt:</label>
            </div>
            <div style={{ position: "relative", display: "inline-block",marginBottom: "10px" }}>
                <input
                    type="text"
                    id="prompt"
                    value={promptText}
                    onChange={(e) => {
                        setPromptText(e.target.value);
                        setMessage("");
                    }}
                    required
                    style={{ padding: "5px", width: "240px" }}
                    disabled={loading}
                />
                {loading && (
                    <div
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            zIndex: 1,
                            background: "rgba(255, 255, 255, 0.8)",
                            borderRadius: "50%",
                            padding: "10px",
                        }}
                    >
                        <Spinner size="medium" />
                    </div>
                )}
            </div>
            <Button onClick={handleTOATOC} appearance="primary" disabled={loading}>
                Submit
            </Button> */}
            <div style={{ marginTop: "10px", color: message.includes("success") ? "green" : "red" }}>
                {message}
            </div>
        </div>

    );
};

export default GeneratePrompt;
